import { useState, useEffect, useMemo } from "react";
import { Flex, message } from "antd";

import NoticesSettingsTable from "@/components/tables/NoticesSettingsTable";
import CustomSelect from "@/components/inputs/CustomSelect";

import { useTableAutoHeight } from "@/hooks/useTableAutoHeight";

import { getAdminNotificationRules, setNotificationRule } from "@/api/notices";

const FILTER_OPTIONS = [
  { label: "Задачи", value: "task" },
  { label: "Объекты", value: "object" },
  { label: "Раб. группы", value: "unit" },
  { label: "Файлы", value: "file" },
];

const formateData = (data) => {
  return data.map((item) => ({
    ...item,
    channels: [...item.default_channels],
    rule_name: item.name,
    rule_description: item.description,
    rule_uuid: item.uuid,
    notification_type: item.notification_type
      ? {
          color: item.notification_type_color,
          description: item.notification_type_description,
          icon: item.notification_type_icon,
          name: item.notification_type,
          uuid: item.notification_type_uuid,
        }
      : null,
  }));
};

const getTreeRules = (settings) => {
  const firstLevel = [];
  const mappingSettings = {};

  settings.forEach((setting) => {
    if (setting.is_group || !setting.parent_rule_uuid) {
      firstLevel.push(setting);
    } else if (setting.parent_rule_uuid) {
      if (!mappingSettings[setting.parent_rule_uuid])
        mappingSettings[setting.parent_rule_uuid] = [];
      mappingSettings[setting.parent_rule_uuid].push(setting);
    }
  });

  return firstLevel.map((setting) => {
    const children = mappingSettings[setting.rule_uuid];
    return {
      ...setting,
      ...(children && { children }),
    };
  });
};

const TriggersTab = () => {
  const [pending, setPending] = useState(true);

  const [currentFilter, setCurrentFilter] = useState(null);

  const [rules, setRules] = useState([]);

  const tableData = useMemo(() => {
    if (currentFilter) {
      return rules.filter((rule) => rule.trigger_object_type === currentFilter);
    } else {
      return rules;
    }
  }, [currentFilter, rules]);

  const { tableContainerRef, tableHeight, headerHeight } = useTableAutoHeight([
    tableData,
  ]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    setPending(true);
    try {
      const rules = await getAdminNotificationRules();
      setRules(getTreeRules(formateData(rules)));
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    } finally {
      setPending(false);
    }
  };

  const handleSaveSettings = async (settings) => {
    setPending(true);
    try {
      await setNotificationRule(settings);
      fetchData();
    } catch (error) {
      message.open({
        type: "error",
        content: error.message,
        duration: 10,
      });
    } finally {
      setPending(false);
    }
  };

  return (
    <Flex vertical gap={20} className="h-100">
      <CustomSelect
        placeholder="Раздел"
        options={FILTER_OPTIONS}
        style={{
          width: 130,
        }}
        showSearch
        allowClear
        value={currentFilter}
        onChange={setCurrentFilter}
      />

      <div ref={tableContainerRef} style={{ flex: 1, minHeight: 0 }}>
        <NoticesSettingsTable
          isSettings
          data={tableData}
          loading={pending}
          onChange={handleSaveSettings}
          scroll={{ x: "100%", y: tableHeight - headerHeight }}
        />
      </div>
    </Flex>
  );
};

export default TriggersTab;
